<script setup>
import { __, getFormValuesFromLocalStorage } from '@/utils';
import { ref } from 'vue';

const savedFields = getFormValuesFromLocalStorage();
const roamingNumber = ref(savedFields?.roamingCustomerNumber ? savedFields.roamingCustomerNumber : '');

const plan = JSON.parse(localStorage.getItem('formRoaming')); 


const planUnits = {
	'minutes' : __('minutes'),
};
const translatedUnit = plan?.volumes?.[0]?.unit.toLowerCase() === 'minutes' ? planUnits['minutes'] : plan?.volumes?.[0]?.unit.toUpperCase();

const availableGB = plan?.volumes?.[0]?.volume + ' ' + translatedUnit;

const ClearLocalStorage = () => {
    localStorage.removeItem('formValues');
    localStorage.removeItem('formFragmentValues');
	localStorage.removeItem('formRoaming');
}

const usageTypes = {
	'data' : __('Data only'),
	'call' : __('SMS - Minutes'),
	'data_calls' : __('Surfing and talking'),
};
const  roamingUsage = ref('');
const volumes = plan?.volumes.map(item => item.usage_type);

if(volumes.length === 1){
	roamingUsage.value = usageTypes['data'];
} else if(volumes.length === 2){
	roamingUsage.value = usageTypes['call'];
} else {
	roamingUsage.value = usageTypes['data_calls'];
}
</script>
<template>
	<div class="congrats">
		<div class="congrats__inner">
			<div class="congrats__heading">
				<h3 class="gradient">
					{{ __('How fun') }}, <span dir="rtl">{{ plan?.account_first_name }}</span>!
                    {{ __('We wish you a pleasant flight.') }}
                </h3>
				<h3>
                    {{ __('Details of the package you purchased') }}
                </h3>
			</div>

			<img class="congrats__inner-image" :src="`${theme_path.url}/resources/images/svg/icon-plane-stars.svg`" alt="">

			<div class="package-details" v-if="plan">
				
				<div class="package-details__item">
					<div class="package-details__item-image">
						<img class="smartphone-image" :src="`${theme_path.url}/resources/images/svg/smartphone.svg`" alt="">
						<img class="small-badge-image" :src="`${theme_path.url}/resources/images/svg/badge-icon.svg`" alt="">
						<span>1</span>
					</div><!-- /.package-details__item-image -->

					<p>
                        <strong>
                            {{ roamingNumber }}
                        </strong>
                    </p>
					<p>{{ plan?.name_heb }}</p>
					<p> {{ availableGB }} בעלות ₪{{ plan?.price}} </p>
					<p>{{ roamingUsage }}</p>
				</div><!-- /.package-details__item -->

			</div><!-- /.package-details -->

			<div class="success-cta-row">
				<a
                    href="/roaming"
                    class="btn btn--arrows w156"
                    @click="ClearLocalStorage"
                >
                {{ __('To the homepage') }}
                </a>
			</div>
		</div>
	</div>
</template>